import React, { useEffect, useState, useCallback } from "react";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import cssClasses from "../../Modals/TimeLineAndNotes/TimeLineAndNotes.module.css";
import Close from "../../Components/Icons/Close";
import Button from "../../Subcomponents/Button";
import { errorTost } from "../../Services/Toast";
import backArrow from "../../Assets/Images/backArrow.svg";

import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import DoneIcon from "@mui/icons-material/Done";
import CircleIcon from "@mui/icons-material/Circle";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";

//icons
import Dot from "../../Components/Icons/Dot";
import PaymentIcon from "../../Components/Icons/PaymentIcon";
import Call from "../../Components/Icons/Call";
import SiteVisitIcon from "../../Components/Icons/SiteVisitIcon";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import NoNoteFound from "../../Assets/Images/NoNoteFound.svg";
import InfoIcon from "../../Components/Icons/InfoIcon";

import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
//Modal
// import AddNote from "../AddNote/AddNote";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
//service
import { getNotes, getLeadStatus, getCpPaymentLogs } from "../../Services/LeadNotes";
import { dismissLoader, presentLoader } from "../../Services/loader";
import { getSalesManagerName } from "../../Services/LeadService";

const useStyles = makeStyles((theme) => ({
  wrapperIcons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-around",
    marginBottom: "2rem",
    position: "relative",
  },
  closeIcon: {
    cursor: "pointer",
    position: "absolute",
    right: "1.7rem",
    top: "1.7rem",
  },
  title: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.8rem",
    lineHeight: "2.8rem",
    color: "#101828",
    marginBottom: "0.8rem",
  },
  subTitle: {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#667085",
    marginBottom: "3.2rem",
  },
  wrapperButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    columnGap: "1.2rem",
  },
  backArrow: {
    verticalAlign: "middle",
    cursor: "pointer",
  },
  personName: {
    fontFamily: "Inter-SemiBold",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "1.6rem",
    lineHeight: "2.4rem",
    /* identical to box height, or 150% */

    /* Base/Black */

    color: "#000000",
  },
  id: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.2rem",
    lineheight: "1.8rem",
    /* or 150% */
    /* Gray/500 */
    color: "#667085",
  },
  projects: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.6rem",
    lineheight: "2.4rem",
    color: "#344054",
  },
  blockTitle: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.6rem",
    lineheight: "2.4rem",
    color: " #667085",
  },
  blockValue: {
    fontFamily: "Inter-Regular",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.6rem",
    lineheight: "2.4rem",
    color: "#000000",
    textTransform: "capitalize",
  },
  statusTitle: {
    fontFamily: "Inter-SemiBold",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "2.4rem",
    lineHeight: "3.2rem",
    /* identical to box height, or 133% */

    /* Gray/900 */

    color: "#101828",
  },
  leadId: {
    fontFamily: "Inter-Regular",
    fonStyle: "normal",
    fonWeight: "400",
    fontSize: "1.2rem",
    lineHeight: "1.8rem",
    color: " #667085",
  },
}));

export default function PaymentTimeLineAndNotes({ open, data, handleClose }) {
    console.log('PaymentTimeLineAndNotes dta ',data);
    
  const classes = useStyles();
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [mainTabs, setMainTabs] = useState([]);
  const [notes, setNotes] = useState([]);
  const [addNoteModal, setAddNoteModal] = useState(false);
  const [noNotesFound, setNoNotesFound] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [loadingStatus, setLoadingStatus] = useState(0);
  const [listItemsContainerRef, setListItemsContainerRef] = useState();
  const [confirmationAlertModal, setConfirmationAlertModal] = useState(false);
  const [reasonMessage, setReasonMessage] = useState("");
   const [salesManagerName, setSalesManagerName] = useState("");
     
    useEffect(() => {
      const fetchSalesManagerName = async () => {
        const name = await getSalesManagerName(data?.leadData?.leadId);
    
        setSalesManagerName(name);
      };
  
      fetchSalesManagerName();
    }, [data]);

    
  const onlistItemsContainerRefChange = useCallback((node) => {
    console.log(node);
    if (node !== null) {
      setListItemsContainerRef(node);
    }
  }, []);
  useEffect(() => {
    getAllNotes(0);
    getCpPaymentLogs(data.id)
      .then((statusLogs) => {
        console.log("status",statusLogs)
        console.log(mainTabs[mainTabs.length - 1]);
        statusLogs.data = statusLogs.data.map((each, index) => ({
          ...each,
          status: each.Type,
          message:each.Message,
          created_at: each.created_at,
          isSelected: statusLogs.data.length === index + 1,
          index: index,
        //   Reason:
        //     (each.Reason === null
        //       ? (each.leadStatus === "Unclaimed"
        //           ? "Created"
        //           : each.leadStatus) + " by "
        //       : each.Reason) +
        //     (each?.userId === null
        //       ? each?.cpId?.billingName
        //       : each?.userId?.name),
        }));
        console.log({ statusLogs });
        setMainTabs([...statusLogs.data]);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [data?.CPpaymentId]);
  useEffect(() => {
    console.log(loadingStatus);
  }, [loadingStatus]);

  console.log(data);

  function getAllNotes(_pageNumber) {
    console.log(loadingStatus);
    getNotes(
      data.leadId,
      null,
      _pageNumber * pageSize,
      _pageNumber * pageSize + pageSize - 1
    )
      .then((resp) => {
        console.log(resp.data.length, resp.count);
        if (resp.count > resp.data.length) {
          setLoadingStatus(0);
          setPageNumber(1);
        } else {
          setLoadingStatus(-1);
          setPageNumber(0);
        }
        if (resp.count > 0) {
          setNoNotesFound(true);
        } else {
          setNoNotesFound(false);
        }

        setNotes([...resp.data]);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // function getMoreData() {
  //   console.log("pageNumber", pageNumber);
  //   console.log("loadingStatus =>", loadingStatus);
  //   if (loadingStatus !== 0) return;
  //   setLoadingStatus(1);
  //   presentLoader();
  //   getNotes(
  //     data.personid,
  //     null,
  //     pageNumber * pageSize,
  //     pageNumber * pageSize + pageSize - 1
  //   )
  //     .then((resp) => {
  //       dismissLoader();
  //       console.log({ resp });
  //       if (resp.count > resp.data.length + notes.length) {
  //         setLoadingStatus(0);
  //         setPageNumber(pageNumber + 1);
  //       } else {
  //         setLoadingStatus(-1);
  //         setPageNumber(0);
  //       }

  //       setNotes((pre) => [...pre, ...resp.data]);
  //     })
  //     .catch((err) => {
  //       dismissLoader();
  //       console.log(err.message);
  //       errorTost(err.message);
  //     });
  //   // setLoadingStatus(0);
  // }

  function closeModal() {
    handleClose();
  }
  const timeLine = mainTabs.map((timelineItem, timelineIndex) => {
    // timelineIndex === 1 &&
    //   timelineItem?.status === "Claimed" &&
    //   mainTabs[mainTabs.length - 1]?.status === "Unclaimed" ? (
    //   <></>
    // ) :
    return (
      <Timeline
        position="right"
        sx={[
          {
            padding: "0rem !important",
            [`& .MuiTimeline-root `]: {
              padding: "0rem !important",
            },

            "& . MuiTypography-root": {
              padding: "19px 16px !important",
            },
            [`& .MuiTimelineItem-root:before`]: {
              flex: "0rem !important",
              padding: "0rem !important",
              "-webkitFlex": "none !important",
              //  content:'none '
            },
          },
        ]}
      >
        <TimelineItem key={`TimelineItem_${timelineIndex}`}>
          {/* color={timelineItem.isSelected ? `primary` : "grey"} */}
          <TimelineSeparator>
            <TimelineDot sx={{ backgroundColor: "rgba(11, 165, 236, 0.3)" }}>
              {/* {timelineItem.isCompleted ? (
                <DoneIcon />
              ) : (
                <CircleIcon color={timelineIndex === 0 ? `primary` : "grey"} />
              )} */}
              {timelineItem.isCompleted ? (
                <DoneIcon />
              ) : (
                <DoneIcon
                  className={
                    timelineIndex === 0 ? cssClasses.active : cssClasses.all
                  }
                />
              )}
            </TimelineDot>
            {timelineIndex !== mainTabs.length - 1 && <TimelineConnector />}
          </TimelineSeparator>
          <TimelineContent>
            <Typography
              // fontFamily={"Roboto-Regular"}
              // color={timelineItem.isSelected ? `primary` : "#667085"}
              fontSize={"1.4rem"}
              style={{
                paddingTop: "1rem",
                textDecoration: timelineItem.isCompleted
                  ? "line-through"
                  : "none",
              }}
            >
              <span
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#000000",
                  lineHeight: "2rem",
                  verticalAlign: "middle",
                  marginRight: "0.5rem",
                }}
              >
                {/* {timelineItem.status === "Unclaimed" ||
                timelineIndex === mainTabs[mainTabs.length - 1]?.index
                  ? "Lead Created"
                  : timelineItem.status} */}
                {timelineItem.status}
              </span>
              {/* <span
                style={{
                  fontSize: "1.4rem",
                  fontFamily: "Inter-Medium",
                  color: "#475467",
                  lineHeight: "1.8rem",
                  verticalAlign: "middle",
                  marginRight: "0.5rem",
                }}
              >
                {new Date(timelineItem.created_at).toDateString()},{" "}
                {new Date(timelineItem.created_at).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span> */}

              {/* <InfoOutlinedIcon
                style={{
                  fontSize: "2rem",
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (
                    timelineItem?.Reason === "" ||
                    timelineItem?.Reason === null
                  ) {
                    errorTost("No Information available");
                  } else {
                    setConfirmationAlertModal(true);
                    setReasonMessage(timelineItem?.Reason);
                  }
                }}
              ></InfoOutlinedIcon> */}
            </Typography>
            <div
              style={{
                fontSize: "1.4rem",
                fontFamily: "Inter-Medium",
                color: "#475467",
                lineHeight: "2rem",
                verticalAlign: "middle",
                marginRight: "0.5rem",
              }}
            >
              {timelineItem?.message}
            </div>
            <div
              style={{
                fontSize: "1.4rem",
                fontFamily: "Inter-Medium",
                color: "#475467",
                lineHeight: "1.8rem",
                verticalAlign: "middle",
                marginRight: "0.5rem",
                marginBottom: "0.5rem",
                marginTop: "0.5rem",
              }}
            >
              {new Date(timelineItem.created_at).toDateString()},{" "}
              {new Date(timelineItem.created_at).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    );
  });
  function returnResFromNote(value) {
    console.log(value);
    if (value) {
      setPageNumber(0);
      setLoadingStatus(0);
      setNotes([]);
      getAllNotes(0);
    }
  }
  //   const NotesCard =
  return (
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick") {
          closeModal();
        }
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[
        {
          ".MuiBackdrop-root": {
            background: "rgba(52, 64, 84, 0.7)",
          },
        },
      ]}
      disableAutoFocus={true}
      // button
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.wrapperContent}>
          <div className={cssClasses.header}>
            <div className={cssClasses.headerTitle}>
              
              <div>Timeline And Notes</div>
            </div>
            <span
              className={classes.closeIcon}
              onClick={closeModal}
              tabIndex={0}
            >
              <Close width={"1.5rem"} height={"1.5rem"} />
            </span>
          </div>
          <div className={cssClasses.content}>
            <div className={cssClasses.wrapperFirstRow}>
              <div className={cssClasses.wrapperNameProjects}>
                <div className={cssClasses.block}>
                  <span className={classes.personName}>{data.personData?.name}</span>
                  <div className={classes.leadId}>
                    {"VJ" +
                      data?.leadData?.leadDisplayId?.replace(
                        data?.leadData?.leadDisplayId?.substring(8, 12),
                        "-" + data?.leadData?.leadDisplayId?.substring(8, 12)
                      )}
                  </div>
                </div>
                <div className={cssClasses.block}>
                  <div className={classes.projects}>
                    {data.projectData?.projectName } | {data.inventoryDataForLead?.unitNo}
                  </div>
                </div>
              </div>
              <div className={cssClasses.wrapperNames}>
                <div className={cssClasses.block}>
                  <div className={classes.blockTitle}>CP:</div>
                  <div className={classes.blockValue}>
                    {data.CP_Ladger_Name ?? "-"}
                  </div>
                </div>
                <div className={cssClasses.block}>
                  <div className={classes.blockTitle}>FoS :</div>
                  <div className={classes.blockValue}>{data.fosData?.name ?? "-"}</div>
                </div>
                <div className={cssClasses.block}>
                  <div className={classes.blockTitle}>
                    Sales Representative :
                  </div>
                  <div className={classes.blockValue}>
                    {salesManagerName ?? "-"}
                  </div>
                </div>
              </div>
            </div>
            <div className={cssClasses.wrapperSecondRow}>
              <div className={cssClasses.wrapperStatusLeftSide}>
                <div className={cssClasses.wrapperStatus}>
                  <div className={classes.statusTitle}>STATUS</div>
                  <div className={cssClasses.progressCardWrapper}>
                    {timeLine}
                  </div>
                </div>
              </div>
              {/* <div className={cssClasses.wrapperAddNotesRightSide}> */}
                
                {/* <div
                  className={cssClasses.wrapperNotesCard}
                  id="scrollableDiv"
                  ref={onlistItemsContainerRefChange}
                >
                  {listItemsContainerRef && (
                    <InfiniteScroll
                      dataLength={notes.length}
                      next={getMoreData}
                      style={{ display: "flex", flexDirection: "column" }}
                      hasMore={loadingStatus === 0}
                      // loader={<h4>Loading...</h4>}
                      scrollableTarget={listItemsContainerRef}
                    >
                      {notes.map((note, index) => {
                        return (
                          <div key={index}>
                            <div className={cssClasses.wrapperChips}>
                              {note.noteType === "Call" && (
                                <LeadStatusChip
                                  style={{
                                    color: "#027A48",
                                    backgroundColor: "#ECFDF3",
                                  }}
                                  label={note.noteType}
                                  icon={<Call width={"1rem"} height={"1rem"} />}
                                />
                              )}
                              {note.noteType === "Site Visit" && (
                                <LeadStatusChip
                                  style={{
                                    color: "#3538CD",
                                    backgroundColor: "#EEF4FF",
                                  }}
                                  label={note.noteType}
                                  icon={
                                    <SiteVisitIcon
                                      width={"1rem"}
                                      height={"1rem"}
                                    />
                                  }
                                />
                              )}
                              {note.noteType === "Payment Link Sent" && (
                                <LeadStatusChip
                                  style={{
                                    color: "#B54708",
                                    backgroundColor: "#EEF4FF",
                                  }}
                                  label={note.noteType}
                                  icon={
                                    <PaymentIcon
                                      width={"1rem"}
                                      height={"1rem"}
                                    />
                                  }
                                />
                              )}
                              <div className={cssClasses.callType}>
                                {note.callType}
                              </div>
                              <div className={cssClasses.wrapperContainer}>
                                <div
                                  className={cssClasses.wrapperTime}
                                  style={{ color: "#101828" }}
                                >
                                  <CalendarTodayOutlinedIcon
                                    style={{ color: "#1018289" }}
                                  />
                                 
                                </div>

                                <div
                                  className={cssClasses.lastUpdatedText}
                                  style={{
                                    color: "#344054",
                                    marginLeft: "1rem",
                                  }}
                                >
                                  <p>
                                    {new Date(note.created_at).toDateString()},{" "}
                                    {new Date(
                                      note.created_at
                                    ).toLocaleTimeString([], {
                                      hour: "2-digit",
                                      minute: "2-digit",
                                    })}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className={cssClasses.notesTitle}>
                              {note.title}
                            </div>
                            <div className={cssClasses.notesSubTitle}>
                              {note.description}
                            </div>
                            <div className={cssClasses.border}></div>
                          </div>
                        );
                      })}
                      {noNotesFound === false && (
                        <div className={cssClasses.wrapperNoNotesFound}>
                          <img src={NoNoteFound} alt={"No note Found"} />
                          <span className={cssClasses.noNotesText}>
                            No notes found
                          </span>
                        </div>
                      )}
                    </InfiniteScroll>
                  )}
                </div> */}
              {/* </div> */}
            </div>
          </div>
        </div>
        {/* {addNoteModal && (
          <AddNote
            open={addNoteModal}
            handleClose={() => {
              setAddNoteModal(false);
            }}
            returnRes={returnResFromNote}
            data={data}
          />
        )} */}
        {confirmationAlertModal && (
          <ConfirmationAlert
            open={confirmationAlertModal}
            close={() => {
              setConfirmationAlertModal(false);
            }}
            icon={<InfoIcon width={"4.8rem"} height={"4.8rem"} />}
            title={"Information"}
            subTitle={reasonMessage}
            confirm={(value) => {
              setConfirmationAlertModal(false);
              console.log(value);
            }}
            // buttonTitle={"Close"}
          />
        )}
      </Box>
    </Modal>
  );
}
